import {get,post} from '@/axios'
//菜单
export const roleMenu = p =>post('menu/roleMenu',p);


// WEBPACK FOOTER //
// ./src/api/system/menu.js